var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "employeeProfileValidation",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var invalid = ref.invalid
          var validate = ref.validate
          return [
            _c(
              "b-form",
              {
                staticClass: "mt-2",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { sm: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "First Name*",
                              "label-for": "fname",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                rules: "required|valid-name",
                                name: "first name",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            required: "",
                                            placeholder: "First Name",
                                            name: "fname",
                                            disabled: !_vm.isEdit,
                                            state:
                                              errors.length > 0 ? false : null,
                                          },
                                          model: {
                                            value:
                                              _vm.employeeProfile.firstName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.employeeProfile,
                                                "firstName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "employeeProfile.firstName",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-danger text-end",
                                              },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { sm: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Last Name*",
                              "label-for": "lname",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                rules: "required|valid-name",
                                name: "last name",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            name: "lname",
                                            placeholder: "Last Name",
                                            disabled: !_vm.isEdit,
                                            state:
                                              errors.length > 0 ? false : null,
                                            required: "",
                                          },
                                          model: {
                                            value: _vm.employeeProfile.lastName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.employeeProfile,
                                                "lastName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "employeeProfile.lastName",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-danger text-end",
                                              },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { sm: "6" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "E-mail*", "label-for": "email" } },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required", name: "email" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            type: "email",
                                            name: "email",
                                            placeholder: "Email",
                                            disabled: !_vm.isEdit,
                                            state:
                                              errors.length > 0 ? false : null,
                                            required: "",
                                          },
                                          model: {
                                            value: _vm.employeeProfile.email,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.employeeProfile,
                                                "email",
                                                $$v
                                              )
                                            },
                                            expression: "employeeProfile.email",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-danger text-end",
                                              },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { sm: "6" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "NIC*", "label-for": "nic" } },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required", name: "nic" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            required: "",
                                            placeholder: "NIC",
                                            maxlength: "14",
                                            name: "nic",
                                            disabled: !_vm.isEdit,
                                            state:
                                              errors.length > 0 ? false : null,
                                          },
                                          on: {
                                            keypress: function ($event) {
                                              return _vm.allowAlphaNumeric(
                                                $event
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.employeeProfile.nic,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.employeeProfile,
                                                "nic",
                                                $$v
                                              )
                                            },
                                            expression: "employeeProfile.nic",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-danger text-end",
                                              },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { sm: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Phone Number*",
                              "label-for": "phoneNumber",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                rules: "required",
                                name: "Phone Number",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            name: "phoneNumber",
                                            type: "number",
                                            placeholder: "Phone Number",
                                            disabled: !_vm.isEdit,
                                            state:
                                              errors.length > 0 ? false : null,
                                            required: "",
                                          },
                                          model: {
                                            value:
                                              _vm.employeeProfile.phoneNumber,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.employeeProfile,
                                                "phoneNumber",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "employeeProfile.phoneNumber",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-danger text-end",
                                              },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { sm: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: { label: "Gender*", "label-for": "gender" },
                          },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required", name: "gender" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-select", {
                                          attrs: {
                                            options: _vm.genderOptions,
                                            disabled: !_vm.isEdit,
                                            state:
                                              errors.length > 0 ? false : null,
                                            required: "",
                                          },
                                          model: {
                                            value: _vm.employeeProfile.gender,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.employeeProfile,
                                                "gender",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "employeeProfile.gender",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-danger text-end",
                                              },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { sm: "6" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "DOB*", "label-for": "dob" } },
                          [
                            _c("validation-provider", {
                              attrs: {
                                rules: "required",
                                name: "date of birth",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("DatePicker", {
                                          attrs: {
                                            type: "date",
                                            format: "YYYY-MM-DD",
                                            "value-type": "YYYY-MM-DD",
                                            placeholder: "Select DOB",
                                            clearable: false,
                                            disabled: !_vm.isEdit,
                                            state:
                                              errors.length > 0 ? false : null,
                                            "default-value": null,
                                            editable: false,
                                            "picker-options": {
                                              shortcuts: [],
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.employeeProfile.dateOfBirth,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.employeeProfile,
                                                "dateOfBirth",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "employeeProfile.dateOfBirth",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-danger text-end",
                                              },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { sm: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Country*",
                              "label-for": "country",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required", name: "country" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-select", {
                                          attrs: {
                                            options: _vm.countries,
                                            placeholder: "country",
                                            disabled: !_vm.isEdit,
                                            state:
                                              errors.length > 0 ? false : null,
                                            required: "",
                                          },
                                          model: {
                                            value: _vm.employeeProfile.country,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.employeeProfile,
                                                "country",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "employeeProfile.country",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-danger text-end",
                                              },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { sm: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Address*",
                              "label-for": "address",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required", name: "address" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            name: "address",
                                            placeholder: "Address",
                                            disabled: !_vm.isEdit,
                                            state:
                                              errors.length > 0 ? false : null,
                                            required: "",
                                          },
                                          model: {
                                            value: _vm.employeeProfile.address,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.employeeProfile,
                                                "address",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "employeeProfile.address",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-danger text-end",
                                              },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("CustomFieldsDetails", {
                  attrs: {
                    AdditionalFields: _vm.employeeProfile.additionalFields,
                    ModuleReference: "Employee",
                    ReadOnlyFields: !_vm.isEdit,
                    disabled: _vm.isDisabled,
                  },
                  on: { onchange: _vm.additionalFieldChanges },
                }),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }